import { reduxForm, Field, FieldArray, change } from 'redux-form';
import { connect, useDispatch } from 'react-redux';
import { Input, FileUpload } from '../../../../itrust_common/components/form';
import Alert from '../../../../itrust_common/components/Alert';
import { useEffect } from 'react';

let RenderDoc = props => {
  const { fields, submit, dispatch } = props

  const handleRemoveExamDoc = (member) => {
    Alert.deleteConfirm("Are you sure? You want to delete this record.",
      (res) => {
        if (res) {
          dispatch(change("examAttachedDoc", `${member}[_destroy]`, true));
          setTimeout(() => submit(), 500)
        }
      })
  }

  return (
    <div className="row bg-white">
      {fields.map((member, index, members) => (
        <div key={index} className="col-xl-3 col-md-6 mt-7" style={{ maxHeight: "20rem" }}>
          {index === 0 ?
            <Field name={`${member}[document_attributes]`} onChangeHook={() => { setTimeout(() => submit(), 1000) }} component={FileUpload} imageClasses="img-fluid" labelClasses="d-block" wrapperClasses="col-12 form-group" /> :
            <div className="w-100">
              <div
                onClick={() =>
                  window.open(
                    members.get(index).document_attributes.file.url,
                    '_blank'
                  )
                }
                style={{ cursor: 'pointer' }}
              >
                <embed
                  src={members.get(index).document_attributes.file.url}
                  className="pt-5 img-fluid"
                  style={{
                    height: '12rem',
                    objectFit: 'fit',
                    pointerEvents: 'none'
                  }}
                />
              </div>
              <div className="col-12 my-5 px-0">
                <div className="d-flex">
                  <Field name={`${member}[description]`} placeholder="Enter File description  ..." component={Input} className="form-control" wrapperClasses="form-group mb-0 w-100" onBlur={() => { setTimeout(() => submit(), 100) }} />
                  <div className="dropright d-inline-block float-right badge badge-pill badge-primary px-1 pt-3 ml-5">
                    <button type="button" className="btn p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i className="la la-ellipsis-v" />
                    </button>
                    <div className="dropdown-menu border-0 shadow-sm">
                      <ul className="list-unstyled px-5 mb-0">
                        <li className="py-3 pointer"><a className="text-dark d-block" target="_blank" href={members.get(index).document_attributes.file.url}>View</a></li>
                        <li className="py-3 pointer" onClick={() => handleRemoveExamDoc(member)}>Remove</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      ))}
    </div>
  );
}

function AttachedDocForm(props) {
  const { handleSubmit, template, isTemplate, submit, saving } = props;
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      if (props.dirty) {
        !saving && handleSubmit();
      }
    }
  }, [props.dirty])

  return (
    <form onSubmit={handleSubmit} className="px-7 py-5">
      <FieldArray
        name="patient_documents_attributes"
        props={{
          template: template,
          isTemplate: isTemplate,
          submit: submit,
          dispatch: dispatch
        }}
        component={RenderDoc}
      />
    </form>
  )
}

AttachedDocForm = reduxForm({
  form: 'examAttachedDoc',
  enableReinitialize: true,
})(AttachedDocForm)

const mapStateToProps = state => {
  const { exam } = state
  return {
    saving: exam.saving,
    initialValues: {
      id: exam.exam.id,
      patient_documents_attributes: exam.exam?.patient_documents_attributes ? [{ patient_id: exam.exam?.patient_id }, ...exam.exam?.patient_documents_attributes] : [{ patient_id: exam.exam?.patient_id }]
    }
  }
}

export default connect(mapStateToProps)(AttachedDocForm);